/**
 * Общая шкала важности для выбора между независимыми автоматическими показами.
 * Чем больше значение, тем раньше кандидат рассматривается; порядок внутри одного уровня задаёт `order`.
 * Уровни намеренно не названы по конкретным продуктам, чтобы модель не зависела от Alty, News или подсказок страниц.
 */
export const AUTOMATIC_PRESENTATION_PRIORITIES = {
    /** Для поверхностей, которые должны получить слот раньше обычных подсказок. */
    HIGH: 300,
    /** Основной уровень для автоматических подсказок и сценариев знакомства с интерфейсом. */
    NORMAL: 200,
    /** Для фоновых показов, которые можно отложить до завершения более важных. */
    LOW: 100,
} as const;

/** Ограничивает публичный API значениями общей шкалы и не допускает произвольные числа. */
export type AutomaticPresentationPriority =
    (typeof AUTOMATIC_PRESENTATION_PRIORITIES)[keyof typeof AUTOMATIC_PRESENTATION_PRIORITIES];
